import angular from 'angular';

import Component from './event-schedule.component';

const Module = angular
    .module('control-room.commons.form.components.event-schedule', [])
    .component('crEventSchedule', Component);

export default Module;
